<template>
  <auth-guard
    route
  >
    <v-container>
      <base-title title="Reports" />
      <v-row>
        <v-col
          cols="12"
          md="6"
          v-for="(group, name) in getReportGroups"
          :key="name"
        >
          <v-card
            flat
            class="my-4"
          >
            <v-card-title>
              {{ name }}
            </v-card-title>
            <v-card-text>
              <report-list-item
                v-for="(report, i) in group"
                :key="i"
                :report="report"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </auth-guard>
</template>

<script>
import ReportListItem from '@/views/Reports/components/ReportListItem'
export default {
  name: 'ReportList',
  components: { ReportListItem },
  data: () => ({
    reports: [
      {
        group: 'Coordinating',
        name: 'Final Report List',
        route: 'final-report-list',
        description: 'Final Lot Report List',
        can: 'api.view_finalreport'
      },
      {
        group: 'Coordinating',
        name: 'Hedge Report',
        route: 'hedge-report',
        description: 'Hedge Report',
        // change can permission
        can: 'api.view_hedge'
      },
      // Believe this is deprecated as there are no reports
      {
        addedDate: '2025/9/10',
        group: 'Inventory',
        name: 'Processing Metrics Report',
        route: 'smelter-shipment-history-report',
        description: 'Get history on catalyst weight shipped to smelters',
        can: 'frontend.view_processing_metrics_report'
      }
    ]
  }),
  computed: {
    getReportGroups () {
      // first filter out un-authorized items
      let groups = this.reports.filter(r => this.$store.getters.can(r.can))
      // sort items by name
      groups = groups.sort((a, b) => {
        if (a.name > b.name) return 1
        if (b.name > a.name) return -1
        return 0
      })
      // group the items together by their group name, if the do not have a group go in general
      return groups.reduce((g, item) => {
        const groupName = item.group || 'General'
        if (!g[groupName]) g[groupName] = []
        g[groupName].push(item)
        return g
      }, {})
    }
  }
}
</script>
